<template>
  <div class="windows zeromp">
    <div class="mycontainer zeromp">
      <div class="tile parent-contanier zeromp">
        <div class="tile is-ancestor box is-2 zeromp">
          <sidebar :cargo="this.$route.meta.cargo"/>
        </div>

        <div class="tile is-ancestor is-vertical box is-12 zeromp">
          <div class="tile is-parent is-12 zeromp">
            <article class="tile is-child zeromp">
              <div class="content zeromp">
                <internnavbar />
              </div>
            </article>
          </div>

          <div class="tile is-vertical is-12 internbackground">
            <div class="tile is-parent is-vertical">
              <div class="tile is-child">
                <p class="indextitle">Simulados</p>
                <b-button
                  @click="showFiltersBar"
                  class="lupabusca"
                >
                  <i class="fas fa-search dp-none"></i>
                </b-button>

                <div class>
                  <div id="tabela-simulados">
                    <b-table :data="isEmpty ? [] : simulados" :hoverable="true" :checkable="true">
                      <template slot-scope="props">
                        <!-- colunas-->

                        <b-table-column label="nome">{{ props.row.nome }}</b-table-column>

                        <b-table-column label="grade">{{ props.row.grade }}</b-table-column>

                        <b-table-column
                          label="data"
                        >{{ formatData(props.row.data, 'DD/MM/YYYY - HH:mm') }}</b-table-column>

                        <b-table-column field="actions" label="Ações" width="180" centered>
                          <!-- detalhes -->
                          <b-tooltip label="Detalhes" position="is-top" type="is-dark">
                            <button
                              class="button is-primary is-round"
                              id="info"
                              @click="info(props.row.id), isCardModalActive = true"
                            >
                              <b-icon icon="eye"></b-icon>
                            </button>
                          </b-tooltip>
                        </b-table-column>
                      </template>
                      <template slot="empty">
                        <section class="section">
                          <div class="content has-text-grey has-text-centered">
                            <p>
                              <i class="fas fa-frown-open" style="width:5em;height:5em;"></i>
                            </p>
                            <p>Nada aqui.</p>
                          </div>
                        </section>
                      </template>
                    </b-table>
                  </div>
                </div>

                <b-modal :active.sync="isCardModalActive" style="width=729; height=425;">
                  <div class="card">
                    <div class="card-content">
                      <div class="content">
                        <ul>
                          <li>
                            Nome:
                            <span class="profile-infos-span">{{ simulado.nome }}</span>
                          </li>
                          <li class="separador"></li>
                          <li>
                            Grade:
                            <span class="profile-infos-span">{{ simulado.grade }}</span>
                          </li>
                          <li class="separador"></li>
                          <li>
                            Data:
                            <span
                              class="profile-infos-span"
                            >{{ formatData(simulado.data, "DD/MM/YYYY - HH:MM") }}</span>
                          </li>
                          <li class="separador"></li>
                          <li>
                            Identificação da Escola:
                            <span
                              class="profile-infos-span"
                            >{{ simulado.escola_id }}</span>
                          </li>
                          <li class="separador"></li>
                          <li>
                            Identificação da Proposta:
                            <span
                              class="profile-infos-span"
                            >{{ simulado.proposta_id }}</span>
                          </li>
                          <li class="separador"></li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </b-modal>
              </div>
              <internfooter />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SimuladoService from "@/services/SimuladoService";
import internnavbar from "@/components/Navbars/InternNav";
import internfooter from "@/components/Footers/InternFooter";
import sidebar from "@/components/SideBar/SideBar";
export default {
  data() {
    return {
      simulados: [],
      simulado: [],
      isImageModalActive: false,
      isCardModalActive: false,
      isEmpty: false
    };
  },
  components: {
    internnavbar: internnavbar,
    internfooter: internfooter,
    sidebar: sidebar
  },
  created() {
    SimuladoService.AlunoIndex(this.$route.params.cargo_id).then(result => {
      this.simulados = result;
    });
  },
  methods: {
    deletar(cuuid) {
      if (confirm("você realmente deseja excluir esse simulado?")) {
        SimuladoService.Delete(cuuid)
          .then(() => {
            this.$buefy.toast.open({
              duration: 5000,
              message: "deleção realizado com sucesso!",
              position: "is-top-right",
              type: "is-success"
            });
          })
          .catch(() => {})
          .finally(() => {});
      }
    },
    info(id) {
      SimuladoService.Info(id).then(result => {
        this.simulado = result;
      });
    }
  }
};
</script>